import { useCallback, useEffect, useRef, useState } from "react";


function usePoller(callback: () => void, delay: number) {
  const savedCallback = useRef<() => void>();
  const [isPolling, setIsPolling] = useState<boolean>(false);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }
    if (delay !== null && isPolling) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay, isPolling]);

  const startPolling = useCallback(() => setIsPolling(true), []);
  const stopPolling = useCallback(() => setIsPolling(false), []);

  return [startPolling, stopPolling] as const;
}

export default usePoller;
